import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import {
  Typography,
  Divider,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';

const PREFIX = 'AlertDialog';

const classes = {
  root: `${PREFIX}-root`,
  vettingContainerTitle: `${PREFIX}-vettingContainerTitle`,
  vettingSection: `${PREFIX}-vettingSection`,
  vettingRow: `${PREFIX}-vettingRow`,
  vettingColumn: `${PREFIX}-vettingColumn`,
  dialogFooter: `${PREFIX}-dialogFooter`
};

const StyledDialog = styled(Dialog)((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    '& .MuiDialogTitle-root': {
      padding: theme.spacing(1.5, 3),
    },
  },

  [`& .${classes.vettingContainerTitle}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  [`& .${classes.vettingSection}`]: {
    display: 'flex',
    flexFlow: 'column',
    padding: theme.spacing(3),
    overflowY: 'auto',
  },

  [`& .${classes.vettingRow}`]: {
    'display': 'flex',
    'margin': theme.spacing(1.5, 0),
    'flexFlow': 'row',
    'height': '100%',
    'justifyContent': 'center',
    'width': '100%',
    'alignItems': 'center',
    '&:first-child': {
      marginTop: 0,
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },

  [`& .${classes.vettingColumn}`]: {
    'display': 'flex',
    'flexDirection': 'column',
    'width': '100%',
    'justifyContent': 'center',
    'marginRight': theme.spacing(1),
    'height': '100%',
    '&:last-child': {
      marginRight: 0,
    },
  },

  [`& .${classes.dialogFooter}`]: {
    padding: theme.spacing(1.75, 3),
    borderTop: '1px solid',
    borderTopColor: theme.palette.divider,
  }
}));

export default function AlertDialog(props) {


  return (
    <StyledDialog
      open={props.openAlert}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.root}
      scroll='paper'
    >
      <DialogTitle id="alert-dialog-title" className={classes.vettingContainerTitle}>
        <Typography variant="h6" component="h2">
          {props.titleMessage}
        </Typography>
        <IconButton
          onClick={props.handleAlertClose}
          edge="end"
          aria-label="Close"
          size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <div className={classes.vettingSection}>
        <div className={classes.vettingRow}>
          <div className={classes.vettingColumn}>
            <Alert severity="warning">
              {props.descriptionMessage}
            </Alert>
          </div>
        </div>
      </div>
      <DialogActions className={classes.dialogFooter}>
        {props.children}
      </DialogActions>
    </StyledDialog>
  );
}
AlertDialog.propTypes={
  openAlert: PropTypes.bool.isRequired,
  handleAlertClose: PropTypes.func.isRequired,
  titleMessage: PropTypes.string.isRequired,
  descriptionMessage: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired
};